import {FilterDropdown} from 'src/components/FilterDropdown';

/**
 * Tri-state allocation filter for an account's raw transactions:
 * - all: no server-side narrowing (allocated arg omitted)
 * - allocated: only fully-consumed rows (allocated: true)
 * - unallocated: the to-do queue of rows with unconsumed amount (allocated: false)
 */
export type AllocationFilter = 'all' | 'allocated' | 'unallocated';

/** Decode an allocation filter from a URL query value; anything else is 'all'. */
export const parseAllocationFilter = (
  value: string | null,
): AllocationFilter =>
  value === 'allocated' || value === 'unallocated' ? value : 'all';

type Props = {
  value: AllocationFilter;
  onChange: (value: AllocationFilter) => void;
};

/**
 * Filter pill (styled like DateFilterSelect via FilterDropdown) that drives
 * the query's tri-state `allocated` argument. Replaces the older All/Allocate
 * two-button toggle.
 */
export const AllocationFilterSelect = ({value, onChange}: Props) => (
  <FilterDropdown
    label="Allocation"
    allLabel="All"
    options={[
      {key: 'allocated', label: 'Allocated'},
      {key: 'unallocated', label: 'Unallocated'},
    ]}
    value={value}
    onChange={(key) => onChange(parseAllocationFilter(key))}
  />
);
